/*
 * @Description: 本次专区反馈效果评价
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_19 from './bi-tmpl-detail-19.vue';
export default BiTmplDetail_19;
